module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "advantage-addition-wrapper"
  }, [_c('div', {
    staticClass: "advantage-addition"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteInvestorPagePotentialUser(_vm.userObject.id)
      }
    }
  }), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок"
    },
    on: {
      "change": function($event) {
        return _vm.updateInvestorPagePotentialUser(_vm.userObject)
      }
    },
    model: {
      value: (_vm.userObject.title),
      callback: function($$v) {
        _vm.$set(_vm.userObject, "title", $$v)
      },
      expression: "userObject.title"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('Editor', {
    attrs: {
      "editorToolbar": _vm.customToolbar,
      "id": ("e" + (_vm.userObject.id))
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Кнопка 'читать подробнее'"
    },
    on: {
      "change": function($event) {
        return _vm.updateInvestorPagePotentialUser(_vm.userObject)
      }
    },
    model: {
      value: (_vm.userObject.learnMoreTitle),
      callback: function($$v) {
        _vm.$set(_vm.userObject, "learnMoreTitle", $$v)
      },
      expression: "userObject.learnMoreTitle"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Ссылка"
    },
    on: {
      "change": function($event) {
        return _vm.updateInvestorPagePotentialUser(_vm.userObject)
      }
    },
    model: {
      value: (_vm.userObject.learnMoreLink),
      callback: function($$v) {
        _vm.$set(_vm.userObject, "learnMoreLink", $$v)
      },
      expression: "userObject.learnMoreLink"
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e1b2853"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BondedLoan/investorComponents/PotentialUser.vue
// module id = 964
// module chunks = 0